import { ApplePayLogo } from "@app/components/common/icons";
import { GooglePayLogo } from "@app/components/common/icons";

export const ICON_MAP: Record<
  string,
  React.FC<React.SVGProps<SVGSVGElement>>
> = {
  applePay: ApplePayLogo,
  googlePay: GooglePayLogo,
};
